<div id="mainBody" class="text-center theme-interface">
  <span class="float-right position-absolute closebutton text-decoration-underline font-weight-bold theme-color-header"
    (click)="onYesOrNoPress(true)">{{'public.global.close'
    | translate}}<i class="fas fa-times pl-2 theme-color-header"></i></span>
  <div class="dialog-content">
    <p id="title" class="title theme-color-header">{{'public.global.inActivityCus'|translate}}</p>
    <p id="timeLeft">0:{{ timeLeft }} (m:ss)</p>
    <progress max="45" [value]="timeLeft"></progress>
    <hr>
    <div id="buttonsArea">
      <button (click)="onYesOrNoPress(false)" id="noButton">{{'public.global.inNewOrder'|translate}}</button>
      <div class="buttonsDiv"><button class="btn theme-dark btn-dark py-1" (click)="onYesOrNoPress(true)"
          id="yesButton">{{'public.global.inContinueOrder'|translate}}</button></div>
    </div>
  </div>
</div>